import { array, string } from 'fp-ts';
import { flow } from 'fp-ts/function';
import { memoize } from 'lodash/fp';
import { DEFAULT_LANGUAGE_CODE } from '@mews-commander/constants';
import { getLanguageCode } from '@mews-commander/core';
import { getLanguages } from '@mews-commander/core/legacy-globalization';
import { getCurrentEnterpriseDefaultLanguageCode } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';

const memoizeWithResolver = (memoize as $TSFixMe).convert({ fixed: false });

// localization
export const getTextLocalizationInfo = (
    state: $TSFixMe,
    { languageCode = getLanguageCode(), propertyLanguageCode = getCurrentEnterpriseDefaultLanguageCode(state) } = {}
) => memoizedTextLocalizationInfo(state, { languageCode, propertyLanguageCode });

/**
 * @param userProfileLanguageCode - language set in user's profile
 * @param propertyLanguageCode - language set in the property settings
 * @param languages - all languages available in the system
 */
export const assembleLanguageChain = (
    userProfileLanguageCode: string,
    propertyLanguageCode: string,
    languages: {
        [p: string]: { fallbackLanguageCode?: string | null };
    }
) => {
    const languageChain = [userProfileLanguageCode];
    for (
        let fallbackLanguageCode = languages[userProfileLanguageCode]?.fallbackLanguageCode;
        fallbackLanguageCode;
        fallbackLanguageCode = languages[fallbackLanguageCode]?.fallbackLanguageCode
    ) {
        // Skip en-US so it won't override the property's language
        if (fallbackLanguageCode !== DEFAULT_LANGUAGE_CODE) {
            languageChain.push(fallbackLanguageCode);
        }
    }

    languageChain.push(propertyLanguageCode);
    for (
        let fallbackLanguageCode = languages[propertyLanguageCode]?.fallbackLanguageCode;
        fallbackLanguageCode;
        fallbackLanguageCode = languages[fallbackLanguageCode]?.fallbackLanguageCode
    ) {
        languageChain.push(fallbackLanguageCode);
    }

    // remove duplicates (e.g. when profile and property have set the same language)
    const languageCodes = array.uniq(string.Eq)(languageChain);
    return languageCodes;
};

const memoizedTextLocalizationInfo = memoizeWithResolver(
    (state: $TSFixMe, { languageCode, propertyLanguageCode }: $TSFixMe) => {
        const languages: { [languageCode: string]: { fallbackLanguageCode?: string | null } } = getLanguages(state);
        const languageCodes = assembleLanguageChain(languageCode, propertyLanguageCode, languages);

        return {
            languageCodes,
        };
    },
    (__: $TSFixMe, { languageCode }: $TSFixMe) => languageCode
);

export const getLanguageChain = flow(getTextLocalizationInfo, ({ languageCodes }) => languageCodes);
